<template>
  <div>
    <v-container class="ma-0">
      <v-row class="ma-0">
        <v-col class="ma-0 pa-0">
          <v-checkbox v-model="checkAll" :label="`Выбрать все`"></v-checkbox>
        </v-col>
      </v-row>
    </v-container>

    <v-container class="ma-0">
      <v-simple-table class="ma-0">
        <template v-slot:default>
          <thead>
            <tr>
              <th>Выбрать</th>
              <th>Название</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in checkItems" :key="item.name">
              <td class="p-l-20">
                <v-checkbox v-model="item.checked" @change="itemChange"></v-checkbox>
              </td>
              <td>{{ item.name }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "wapi-select-list",
  props: {
    value: {
      type: Array,
      default: function() {
        return [];
      }
    },
    items: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      checkItems: []
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.checkItems = this.items.map(x => {
          return {
            name: x,
            checked: val.includes(x)
          };
        });
      }
    },
    items: function(val) {
      this.checkItems = val.map(x => {
        return {
          name: x,
          checked: this.value.includes(x)
        };
      });
    }
  },
  computed: {
    checkAll: {
      get: function() {
        if (this.checkItems.length) {
          return !this.checkItems.some(x => !x.checked);
        }
        return false;
      },
      set: function(value) {
        this.checkItems.forEach(x => (x.checked = value));
        this.$emit(
          "input",
          this.checkItems.filter(x => x.checked).map(x => x.name)
        );
      }
    }
  },
  methods: {
    itemChange() {
      this.$emit(
        "input",
        this.checkItems.filter(x => x.checked).map(x => x.name)
      );
    }
  }
};
</script>